import { jwtDecode } from 'jwt-decode';

export function decodeToken(token) {
	if (!token) return null;

	try {
		return jwtDecode(token);
	} catch {
		// Match jsonwebtoken.decode(): malformed tokens are treated as undecodable.
		return null;
	}
}
